@if(apiLoaded) {
  @if (showSearch) {
    <ng-container [formGroup]="searchGroup">
      <label [ngClass]="{ required: required }" for="addressSearch">
        Smart Search
        <span class="hint">Start typing to search for an address</span>
      </label>

      <input
        id="addressSearch"
        class="address-search"
        autocorrect="off"
        autocapitalization="off"
        spellcheck="off"
        autocomplete="off"
        type="search"
        placeholder="Select or search for address."
        matInput
        formControlName="searchInput"
        [matAutocomplete]="auto"
        (keydown)="preventSubmission($event)"
        #addressSearch
        [ngClass]="{'invalid': addressInValid }"
        aria-describedby="addressSearchErrors"
      >

      <div id="addressSearchErrors" aria-live="assertive" aria-atomic="true">
        @if (searchGroup.get('searchInput').touched) {
          @if (parentForm?.controls?.[controlName]?.invalid) {
            <mat-error role="status">This field is required</mat-error>
          }
          @if (searchGroup.get('searchInput').invalid) {
            <mat-error role="status">Please select a value from the dropdown</mat-error>
          }
        }
      </div>


      <input
        autocomplete="off"
        autocorrect="off"
        autocapitalization="off"
        spellcheck="off"
        type="text"
        aria-label="Address Line 2"
        placeholder="Optional Address Information (house, appt, notes)"
        matInput
        formControlName="address2"
      >

      <mat-autocomplete
        [displayWith]="getDisplayAddress"
        (optionSelected)="updateLocationFromSelection($event)"
        #auto="matAutocomplete"
      >
        @for(option of locationOptions; track option.id || option.address.name || option.address.address1) {
          <mat-option [value]="option">
            @if (!option.isGoogleResult) {
              <span class="favorite">⭐</span>
            }
            <span [ngClass]="{ 'non-geocoded': !isGeoCoded(option), geocoded: isGeoCoded(option) }">
              {{ option.description }}
            </span>
          </mat-option>
        }
      </mat-autocomplete>
    </ng-container>
  }

  <section class="map-and-controls">
    <div class="accessibility-controls">
      <div aria-live="polite" aria-atomic="true" class="sr-only">
        @if (marker && parentForm.get(controlName)?.value?.latitude) {
          Current Address geo-coordinates are:
          <dl>
            <dt>Latitude</dt><dd>{{ parentForm.get(controlName)?.value?.latitude }}</dd>
            <dt>Longitude</dt><dd>{{ parentForm.get(controlName)?.value?.longitude }}</dd>
          </dl>
        }
      </div>
      <div class="directionals">
        @if (marker) {
          <button class="north" type="button" (click)="move('north', $event)"
            aria-label="Move map marker northward"
            matTooltip="Move map marker northward"
          >
            <mat-icon>north</mat-icon>
          </button>
          <button class="west" type="button" (click)="move('west', $event)"
            aria-label="Move map marker westward"
            matTooltip="Move map marker westward"
          >
            <mat-icon>west</mat-icon>
          </button>
          <button class="east" type="button" (click)="move('east', $event)"
            aria-label="Move map marker eastward"
            matTooltip="Move map marker eastward"
          >
            <mat-icon>east</mat-icon>
          </button>
          <button class="south" type="button" (click)="move('south', $event)"
            aria-label="Move map marker southward"
            matTooltip="Move map marker southward"
          >
            <mat-icon>south</mat-icon>
          </button>
        }
      </div>
    </div>
    <div class="map" id="google-maps-container">
      <google-map #map [options]="options" height="" width="" [center]="options.center">
        @if (marker) {
          <map-marker
            [position]="marker.position"
            [options]="marker.options"
            (mapDragend)="updateLocationOnDragEnd($event)"
          >
          </map-marker>
        }
      </google-map>
    </div>
  </section>
}
